import React, { ReactNode } from "react";
import { Box, useStyleConfig, BoxProps } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { useShadcnInsetChrome } from "@/contexts/ShadcnInsetChromeContext";
import { isStrategyRdPathname } from "@/types/strategyRd";
import { isWorkspaceCanvasPathname } from "@/views/Dashboard/Workspace/workspaceRoutes";

interface PanelContentProps extends BoxProps {
  variant?: string;
  children?: ReactNode;
}

function PanelContent(props: PanelContentProps) {
  const { variant, children, ...rest } = props;
  const styles = useStyleConfig("PanelContent", { variant });
  const shadcnInset = useShadcnInsetChrome();
  const { pathname } = useLocation();
  const lockViewport = isWorkspaceCanvasPathname(pathname) || isStrategyRdPathname(pathname);
  const merged = shadcnInset
    ? lockViewport
      ? {
          ...styles,
          ms: 0,
          me: 0,
          ps: 0,
          pe: 0,
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }
      : { ...styles, ms: 0, me: 0, ps: 0, pe: 0 }
    : styles;
  return (
    <Box __css={merged} data-app-panel-content {...rest}>
      {children}
    </Box>
  );
}

export default PanelContent;
